import { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contacto() {
    const [form, setForm] = useState({
        nombres: "",
        apellidos: "",
        correo: "",
        telefono: "",
        servicio: "",
        fecha: "",
        idioma: "",
        mensaje: "",
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const enviarFormulario = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(
                "https://formsubmit.co/ajax/cotizaciones@tradutecperu.com",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(form),
                }
            );

            const data = await response.json();

            if (response.ok) {
                alert("Solicitud enviada correctamente.");

                setForm({
                    nombres: "",
                    apellidos: "",
                    correo: "",
                    telefono: "",
                    servicio: "",
                    fecha: "",
                    idioma: "",
                    mensaje: "",
                });
            } else {
                alert(data.message || "Error al enviar la solicitud.");
            }
        } catch (error) {
            console.error(error);
            alert("No se pudo enviar la solicitud.");
        }
    };

    // const enviarFormulario = async (e) => {
    //     e.preventDefault();

    //     try {
    //         await emailjs.send(
    //             "SERVICE_ID",
    //             "TEMPLATE_ID",
    //             {
    //                 nombres: form.nombres,
    //                 apellidos: form.apellidos,
    //                 correo: form.correo,
    //                 telefono: form.telefono,
    //                 servicio: form.servicio,
    //                 fecha: form.fecha,
    //                 idioma: form.idioma,
    //                 mensaje: form.mensaje,
    //             },
    //             "PUBLIC_KEY"
    //         );

    //         alert("Solicitud enviada correctamente");

    //         setForm({
    //             nombres: "",
    //             apellidos: "",
    //             correo: "",
    //             telefono: "",
    //             servicio: "",
    //             fecha: "",
    //             idioma: "",
    //             mensaje: "",
    //         });

    //     } catch (error) {
    //         console.error(error);
    //         alert("Error al enviar");
    //     }
    // };

    return (
        <section className="contacto" id="contacto">
            <div className="wrap">
                <div className="sec-title">
                    <h2>Contáctenos</h2>
                    <div className="bar"></div>
                </div>

                <form onSubmit={enviarFormulario} className="form-grid">

                    <div className="form-head only-mob">
                        CONTÁCTENOS
                    </div>

                    <div className="form-msg"></div>

                    <div className="field">
                        <label>Nombres</label>
                        {/* <label>
                            <span className="only-desk">
                                Nombres <span className="req">*</span>
                            </span>
                        </label> */}

                        <div className="inp">
                            <i className="fas fa-user"></i>

                            <input
                                type="text"
                                name="nombres"
                                value={form.nombres}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label>Apellidos</label>
                        {/* <label>
                            <span className="only-desk">
                                Apellidos <span className="req">*</span>
                            </span>
                        </label> */}

                        <div className="inp">
                            <i className="fas fa-user"></i>

                            <input
                                type="text"
                                name="apellidos"
                                value={form.apellidos}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label>Correo electrónico</label>

                        <div className="inp">
                            <i className="fas fa-envelope"></i>

                            <input
                                type="email"
                                name="correo"
                                value={form.correo}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label>
                            Teléfono | WhatsApp <span className="req">*</span>
                        </label>

                        <div className="inp">
                            <i className="fab fa-whatsapp"></i>

                            <input
                                type="text"
                                name="telefono"
                                value={form.telefono}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label>Tipo de servicio</label>

                        <div className="inp">
                            <i className="fas fa-briefcase"></i>

                            <select
                                name="servicio"
                                value={form.servicio}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Seleccione...</option>
                                <option value="Traducción certificada">
                                    Traducción certificada
                                </option>
                                <option value="Traducción certificada digital">
                                    Traducción certificada digital
                                </option>
                                <option value="Traducción especializada">
                                    Traducción especializada
                                </option>
                                <option value="Traducción simple">
                                    Traducción simple
                                </option>
                                <option value="Traducción express">
                                    Traducción express
                                </option>
                                <option value="Interpretación simultánea">
                                    Interpretación simultánea
                                </option>
                                <option value="Interpretación consecutiva">
                                    Interpretación consecutiva
                                </option>
                                <option value="Interpretación de enlace">
                                    Interpretación de enlace
                                </option>
                                <option value="Interpretación remota">
                                    Interpretación remota
                                </option>
                            </select>
                        </div>
                    </div>

                    <div className="field">
                        <label>¿Para cuándo lo necesitas?</label>

                        <div className="inp">
                            <i className="far fa-calendar"></i>

                            <input
                                type="date"
                                name="fecha"
                                value={form.fecha}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label>
                            Idioma destino <span className="req">*</span>
                        </label>

                        <div className="inp">
                            <i className="fas fa-globe"></i>

                            <select
                                name="idioma"
                                value={form.idioma}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Seleccione...</option>
                                <option value="Inglés">Inglés</option>
                                <option value="Español">Español</option>
                                <option value="Francés">Francés</option>
                            </select>
                        </div>
                    </div>

                    <div className="field msg">
                        <label>Mensaje</label>

                        <div className="inp">
                            <textarea
                                name="mensaje"
                                value={form.mensaje}
                                onChange={handleChange}
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    <div className="form-foot">
                        <label className="policy">
                            <input type="checkbox" required />
                            {" "}He leído y acepto las Políticas de Tratamiento de Protección de Datos Personales.
                        </label>

                        <button type="submit" className="btn btn-gold">
                            <i className="fas fa-paper-plane"></i>
                            {" "}Enviar solicitud
                        </button>
                    </div>

                </form>
            </div>
        </section>
    );
}